import { useEffect, useState } from "react";

/**
 * O retângulo de um elemento na janela, reposto a cada quadro enquanto ele existe.
 *
 * Um anel desenhado por cima precisa acompanhar rolagem, animação de entrada e mudança de
 * layout de qualquer ancestral; observar tudo isso evento a evento é mais frágil do que medir
 * um elemento por quadro. Só muda o estado quando o retângulo mudou de fato.
 *
 * @param {Element|null} element
 * @returns {{ top: number, left: number, width: number, height: number }|null}
 */
export function useElementRect(element) {
  const [rect, setRect] = useState(null);

  useEffect(() => {
    if (!element) {
      setRect(null);
      return undefined;
    }
    let frame = 0;
    const measure = () => {
      const r = element.getBoundingClientRect();
      setRect((previous) =>
        previous && previous.top === r.top && previous.left === r.left && previous.width === r.width && previous.height === r.height
          ? previous
          : { top: r.top, left: r.left, width: r.width, height: r.height },
      );
      frame = window.requestAnimationFrame(measure);
    };
    measure();
    return () => window.cancelAnimationFrame(frame);
  }, [element]);

  return rect;
}
